import { StyleSheet } from 'aphrodite';
import {
	boardHeaderCompactHeight,
	boardHeaderHeight,
	mediaQueryMaxWidth,
} from '../../../components/dataBoards/opportunities/OpportunitiesBoardHeader/styles';
import { THEME } from '../../../components-v2/Theme/theme';
import { brandPrimary, brandPrimaryText, tagBackgroundColor } from '../../../styles/colors';
import { BreakPoints, CssSelectors, baseStyleSheet } from '../../../styles/styles';

export const styleSheet = StyleSheet.create({
	banner: {
		alignItems: 'center',
		background: tagBackgroundColor,
		display: 'flex',
		padding: '1rem 0.5rem',
	},
	bannerLink: {
		alignItems: 'center',
		color: brandPrimaryText,
		display: 'inline-flex',
		gap: 12,
		...baseStyleSheet.fontBold,
		fontSize: 14,
		textDecoration: 'none',
	},
	bannerLinkText: {
		[`@media (max-width: ${THEME.breakpoints.xxl}px)`]: {
			display: 'none',
		},
	},
	board: {
		background: '#f2f2f2',
		boxSizing: 'border-box',
		height: '100%',
	},
	boardCol: {
		background: '#f2f2f2',
		margin: 0,
		padding: 0,
		...CssSelectors.allDescendants(
			{
				boxSizing: 'border-box',
				margin: 0,
				padding: '0 10px',
			},
			'.kanban-board-column-header'
		),
		...CssSelectors.allDescendants(
			{
				height: '100%',
				margin: 0,
				padding: 0,
				...CssSelectors.allChildren(
					{
						boxSizing: 'border-box',
						flexGrow: 1,
						overflowY: 'auto',
						padding: '0 10px',
						...CssSelectors.allChildren(
							{
								opacity: 0.5,
							},
							'.kanban-board-card-disabled'
						),
					},
					'.kanban-board-cards'
				),
			},
			'.kanban-board-column-content'
		),
	},
	boardContainer: {
		boxSizing: 'border-box',
		height: `calc(100% - ${boardHeaderHeight}px - 30px)`,
		marginBottom: 30,
		maxHeight: `calc(100% - ${boardHeaderHeight}px - 30px)`,
		overflowX: 'auto',
		overflowY: 'hidden',
		position: 'relative',
		[BreakPoints.forMaxWidth(mediaQueryMaxWidth)]: {
			height: `calc(100% - ${boardHeaderCompactHeight}px - 30px)`,
			maxHeight: `calc(100% - ${boardHeaderCompactHeight}px - 30px)`,
		},
	},
	container: {
		boxSizing: 'border-box',
		width: '100%',
		display: `flex`,
		flexDirection: `column`,
	},
	loading: {
		marginTop: '10%',
	},
	placeholder: {
		height: '100%',
		width: '100%',
	},
	automationAnchor: {
		height: 0,
	},
	automationPopover: {
		fontSize: 14,
		letterSpacing: '0',
		padding: '5px 10px',
	},
	automationPopoverMessage: {
		color: '#4a4a4a',
		padding: '5px 12px',
	},
	automationPopoverName: {
		color: brandPrimary,
		padding: '5px 12px',
	},
	automationStartButton: {
		margin: '10px 10px',
		padding: '5px 12px',
	},
	automationXIcon: {
		cursor: 'pointer',
		marginRight: 5,
		textAlign: 'right',
	},
});
